import React from 'react'

import { arrayOf, func, shape, string } from 'prop-types'

function CapabilityGroup({ label, capabilities }) {
  return (
    <div className="ai-sub-landing__capability-group">
      <p className="ai-sub-landing__capability-group-label cgt-caption-semibold">{label}</p>
      <ul className="ai-sub-landing__capability-list">
        {capabilities.map(({ Icon, label: name }) => (
          <li key={name} className="ai-sub-landing__capability">
            <Icon className="ai-sub-landing__capability-icon" width="20" height="20" aria-hidden="true" />
            <span className="ai-sub-landing__capability-label cgt-body-md">{name}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

CapabilityGroup.propTypes = {
  label: string.isRequired,
  capabilities: arrayOf(shape({ Icon: func.isRequired, label: string.isRequired })).isRequired,
}

export default CapabilityGroup
